import { initializeApp, getApps } from "firebase/app";
import { getAnalytics, type Analytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDLBwMq0LSGatGnpDYy0fFmNHYqCVZI_ls",
  authDomain: "urgsalud-a3387.firebaseapp.com",
  projectId: "urgsalud-a3387",
  storageBucket: "urgsalud-a3387.appspot.com",
  messagingSenderId: "594764883269",
  appId: "1:594764883269:web:aa6e02e230c580f6bc8a2c",
};

export const VAPID_KEY = "W8F8dmEazFSrhf6WlnZIQVkOpDb1lcQcvTT4EQ37X0w";

const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

let analytics: Analytics | undefined;
if (typeof window !== "undefined" && firebaseConfig.apiKey) {
  try {
    analytics = getAnalytics(app);
  } catch {
    // Analytics not available
  }
}

export { app, analytics, firebaseConfig };
